const YardAuditReportReducer = (state = {}, action) => {
    switch (action.type) {
      case "YARD_AUDITREPORTS":
        return Object.assign({}, state, {
          yardauditdocnames: action.data,
        });
      case "REPORT_DOCS":
        return Object.assign({}, state, {
          reportdocs: action.data,
        });
        case "HIDE_AUDITDEL":
          return Object.assign({}, state, {
            hideaudit: action.data,
          });
          case "SAVE_AUDITDOC":
          return Object.assign({}, state, {
            saveaudit: action.data,
          });
        default:
      return state;
  }
};
 
export default YardAuditReportReducer;